/* tslint:disable */
/* eslint-disable */
export enum MediaTypeEnum {
  NotSet = 0,
  Image = 1,
  Video = 2
}
